import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const StartReactivationChallenges = gql`
  mutation StartReactivationChallenges {
    startReactivationChallenges {
      ... on ReactivationChallengeSuccess {
        challengeId
        challengeContext
        challengeState
        challengeType
        __typename
      }
      ... on ReactivationChallengeError {
        ...error
        __typename
      }
    }
    __typename
  }
  ${error}
`;

export default StartReactivationChallenges;
